import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { userSelector } from 'selectors/user/userSelector';
import { bottomNavigationSelector } from 'selectors/page/headerFooterTemplate/data/bottomNavigationSelector/bottomNavigationSelector';
import { showBottomNavOffersSelector } from 'viewModel/selectors/testTarget/showBottomNavOffersSelector';
import { superChatSelector } from 'ai/selectors/superChatSelector';
import LanguageLocaleUtils from 'utils/LanguageLocale';
import userUtils from 'utils/User';
import sysUtils from 'utils/ShopYourStore';
import ShopMyStoreActions from 'actions/HappeningShopMyStoreActions';
import ShopSameDayActions from 'actions/HappeningShopSameDayActions';
import HeaderEN from 'components/Header/locales/Header_en_US';
import HeaderFR from 'components/Header/locales/Header_fr_CA';

const { getTextFromResource, getLocalisedDataFromResource } = LanguageLocaleUtils;
const getText = getLocalisedDataFromResource(HeaderEN, HeaderFR);

// Use bot_nav_title from genai-pa config if available, otherwise fall back to locale text
const aiBeautySelector = createSelector(
    [superChatSelector, getTextFromResource(getText, 'aiBeauty')],
    (superChat, localeText) => superChat?.config?.meta?.bot_nav_title || localeText
);

export default connect(
    createSelector(
        userSelector,
        createStructuredSelector({
            tooltip: getTextFromResource(getText, 'tooltip'),
            shop: getTextFromResource(getText, 'shop'),
            community: getTextFromResource(getText, 'community'),
            gallery: getTextFromResource(getText, 'gallery'),
            store: getTextFromResource(getText, 'store'),
            offers: getTextFromResource(getText, 'offers'),
            promos: getTextFromResource(getText, 'promos'),
            deals: getTextFromResource(getText, 'deals'),
            home: getTextFromResource(getText, 'home'),
            me: getTextFromResource(getText, 'me'),
            myStore: getTextFromResource(getText, 'myStore'),
            aiBeauty: aiBeautySelector
        }),
        bottomNavigationSelector,
        showBottomNavOffersSelector,
        (user, localization, bottomNavigation, bottomNavOffersExperience) => {
            const isUserReady = user.isInitialized;
            const isShopYourStoreEnabled = sysUtils.shopYourStoreEnabled();
            const showNewBadgeForSYS = isShopYourStoreEnabled && !sysUtils.shopYourStoreV2Enabled();

            return {
                user,
                isUserReady,
                isAnonymous: isUserReady && userUtils.isAnonymous(),
                localization,
                showNewBadgeForSYS,
                isShopYourStoreEnabled,
                hasPreferredStore: !!user.preferredStore,
                hasPreferredZipCode: !!user.preferredZipCode,
                bottomNavigation,
                bottomNavOffersExperience
            };
        }
    ),
    {
        showStoreSwitcherModal: ShopMyStoreActions.showStoreSwitcherModal,
        showShippingDeliveryLocationModal: ShopSameDayActions.showShippingDeliveryLocationModal
    }
);
